import { VOICES } from '@/mocks/celebrity';

const PRINCIPLES = [
  { icon: 'ri-focus-3-line', title: '只讲依据', desc: '同款、同框与时间线需互相印证，才标注“实锤”，避免单图定案。' },
  { icon: 'ri-refresh-line', title: '澄清即修正', desc: '当事人或工作室回应后，第一时间更新原稿，还原事实全貌。' },
  { icon: 'ri-hand-heart-line', title: '不渲染对立', desc: '克制标题党与拉踩，尊重当事人隐私与情感边界。' },
  { icon: 'ri-book-3-line', title: '有边界的八卦', desc: '涉及隐私、未成年与失实内容一律不上榜、不转载。' },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100/60">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-primary-600">ABOUT US</p>
            <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              关于八卦吃瓜
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-700">
              八卦吃瓜是一档专注<strong className="font-semibold text-foreground-900">明星恋情与绯闻</strong>
              的娱乐资讯栏目，我们不满足于“谁和谁被拍”的零碎爆料，而是把散落在综艺、动态与访谈里的线索，
              整理成有依据、看得懂的<strong className="font-semibold text-foreground-900">恋情与感情线时间线</strong>。
            </p>
            <p className="mt-3 text-sm leading-7 text-foreground-700">
              从<strong className="font-semibold text-foreground-900">恋情公开</strong>、
              <strong className="font-semibold text-foreground-900">约会实锤</strong>到
              <strong className="font-semibold text-foreground-900">分手复合</strong>，我们希望这里的每一个瓜，
              既满足大家的好奇，也经得起时间的检验。吃瓜可以上头，但真相与边界，我们从不让步。
            </p>

            <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {PRINCIPLES.map((p) => (
                <li
                  key={p.title}
                  className="rounded-lg border border-background-200 bg-background-50 p-3"
                >
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${p.icon} text-base`} />
                  </span>
                  <p className="mt-2 text-sm font-semibold text-foreground-900">{p.title}</p>
                  <p className="mt-1 text-xs leading-5 text-foreground-600">{p.desc}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-7">
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-chat-heart-line text-accent-600" />
                网友口碑
              </h3>
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-700">
                已服务 48万+ 吃瓜读者
              </span>
            </div>
            <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
              {VOICES.map((v) => (
                <figure
                  key={v.name}
                  className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-5"
                >
                  <div className="flex text-accent-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm" />
                    ))}
                  </div>
                  <blockquote className="mt-3 flex-1 text-sm leading-6 text-foreground-700">
                    “{v.text}”
                  </blockquote>
                  <figcaption className="mt-4 flex items-center gap-2 border-t border-background-200 pt-3 text-xs text-foreground-500">
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-accent-500 text-background-50">
                      <i className="ri-user-smile-line" />
                    </span>
                    {v.name}
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}